import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import logo from "../Assets/imgs/logo.webp";
import logoScrolled from "../Assets/imgs/logo.png";
import menubar from "../Assets/imgs/menubar.webp";
import {
  headerGSAP,
  headerLogoSwitcherDesktop,
  headerLogoSwitcherMobile,
} from "../utils/GSAPFunctions";

const Header = () => {
  const headerRef = useRef<HTMLDivElement | null>(null);

  const MOBILE_BREAKPOINT = 767;

  useLayoutEffect(() => {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      const ctx = gsap.context(() => {
        if (headerRef.current) {
          headerGSAP(headerRef);
          headerLogoSwitcherMobile();
        }
      }, headerRef);

      return () => ctx.revert(); // cleanup
    }

    const ctx = gsap.context(() => {
      if (headerRef.current) {
        headerGSAP(headerRef);
        headerLogoSwitcherDesktop();
      }
    }, headerRef);

    return () => ctx.revert(); // cleanup
  }, []);

  return (
    <div ref={headerRef}>
      <div className="__headerSection" id="header">
        <div className="container-fluid">
          <div className="__headerWrapper">
            <a href="#" className="logo ">
              <img src={logo} alt="logo" className="default_hlogo" />
              <div className="__scrolledLogo scroll_hlogo">
                <img src={logoScrolled} alt="logo" className="" />
              </div>
              {/* <img
                src={logoScrolled}
                alt="logo"
                className="__scrolledLogo scroll_hlogo"
              /> */}
            </a>
            <div className="__menuBar">
              <img src={menubar} alt="menu" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
